import { render, staticRenderFns } from "./gantt.vue?vue&type=template&id=17a6652a"
import script from "./gantt.vue?vue&type=script&lang=js"
export * from "./gantt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports